import type {
  CreateStationDto,
  Station,
  UpdateStationDto,
} from '@/entities/station/station.entity';
import { Service } from './http-service';
import type { AvailableHolidayRuleDto } from '@carvia/ros-client-types';

export type HolidaySubdivision = {
  code: string;
  name: string;
};

class StationsService extends Service<Station, CreateStationDto, UpdateStationDto> {
  constructor() {
    super('/stations');
  }

  async getOne(id: string) {
    const res = await this.httpClient.get<Station>(`${this.endpoint}/${id}`, {
      params: {
        addHolidays: true,
      },
    });
    return res.data;
  }

  async getHolidaySubdivisions(countryCode: string, lang?: string) {
    const res = await this.httpClient.get<HolidaySubdivision[]>(
      `${this.endpoint}/holiday-subdivisions`,
      {
        params: { countryCode, lang },
      },
    );
    return res.data;
  }

  async getAvailableHolidayRules(countryCode: string, state?: string | null) {
    const res = await this.httpClient.get<AvailableHolidayRuleDto[]>(
      `${this.endpoint}/available-holidays`,
      {
        params: { countryCode, state: state || undefined },
      },
    );
    return res.data;
  }
}

export const stationsService = new StationsService();
